import {
  schedulePublicSchema,
  locationDetailResponseSchema,
  schedulesListResponseSchema,
  type SchedulePublic,
  type LocationDetailResponse,
  type ScheduleMember,
  type ScheduleService,
  type SchedulesListResponse,
} from "@openings/api-contract";
import { BaseHttpClient, baseOk, type ApiOk } from "./base";

const listOk = baseOk(schedulesListResponseSchema);
const detailOk = baseOk(locationDetailResponseSchema);
const scheduleOk = baseOk(schedulePublicSchema);

/** Schedule is the new location — these aliases remain for backward compat */
export type LocationDTO = SchedulePublic;
export type LocationMemberDTO = ScheduleMember;
export type LocationServiceDTO = ScheduleService;
export type LocationsListResult = ApiOk<SchedulesListResponse>;
export type LocationDetailResult = ApiOk<LocationDetailResponse>;

/** @deprecated Use the openings/schedules methods instead */
export class LocationsClient extends BaseHttpClient {
  listBySalon(salonId: string): Promise<LocationsListResult> {
    const qs = new URLSearchParams({ salonId });
    return this.get<LocationsListResult>(
      `/v1/locations?${qs.toString()}`,
      listOk
    );
  }
  getById(scheduleId: string) {
    return this.get<ApiOk<LocationDTO>>(
      `/v1/locations/${encodeURIComponent(scheduleId)}`,
      scheduleOk
    );
  }
  getDetail(scheduleId: string): Promise<LocationDetailResult> {
    return this.get<LocationDetailResult>(
      `/v1/locations/${encodeURIComponent(scheduleId)}/detail`,
      detailOk
    );
  }
}
